import { JsonObject } from '@/lib/helpers';
import { PropModel } from './prop.model';

export class RecentServiceModel extends PropModel {
  serviceId: string;
  mostRecentVisitTimestamp: number;

  constructor(props: JsonObject = {}) {
    super();

    const data = props as Record<keyof RecentServiceModel, unknown>;
    this.serviceId = (data.serviceId as string) || '';
    this.mostRecentVisitTimestamp = (data.mostRecentVisitTimestamp as number) || 0;
  }
}
